import { define, ui } from '@owenscorning/pcb.alpha';

import {
  CALIPER_SECTIONS,
  DEFAULT_HEADER,
  DISPLACEMENT_SECTIONS,
} from '../../../../Insulation/DensityCalculator/constants';
// eslint-disable-next-line import/no-cycle
import Renderer from '../../../../OC/PageBuilder/DensityCalculator';

export default define`Density Calculator`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/DensityCalculator`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  // eslint-disable-next-line react/jsx-props-no-spreading
  view: ({ value }) => <Renderer {...value} />,
  edit: {
    header: ui`Content/Basic`({
      label: 'Header',
      description: 'The header for the calculator',
      default: DEFAULT_HEADER,
    }),
    displacementSections: ui`Form`.of(
      ui`List`.of(
        ui`Form`.of({
          title: ui`Text`({ label: 'Title' }),
          content: ui`Text/Rich`({ label: 'Content' }),
          images: ui`List`.of({
            image: ui`Image`,
            caption: ui`Text`({ label: 'Caption', optional: true }),
          })({
            label: 'Images',
            min: 1,
            max: 3,
          }),
        })
      )
    )({
      label: `Displacement Sections`,
      default: DISPLACEMENT_SECTIONS,
      compact: true,
      hideable: true,
      standalone: true,
    }),
    caliperSections: ui`Form`.of(
      ui`List`.of(
        ui`Form`.of({
          title: ui`Text`({ label: 'Title' }),
          content: ui`Text/Rich`({ label: 'Content' }),
          images: ui`List`.of({
            image: ui`Image`,
            caption: ui`Text`({ label: 'Caption', optional: true }),
          })({
            label: 'Images',
            min: 1,
            max: 3,
          }),
        })
      )
    )({ label: `Caliper Sections`, default: CALIPER_SECTIONS, compact: true, hideable: true, standalone: true }),
  },
});
